    import React from "react";
    import axios from "axios";


    import {
      Dialog,
      DialogTitle,
      DialogContent,
      DialogActions,
      Grid,
      TextField,
      MenuItem,
      Button,
    } from "@mui/material";
    
    

    const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

    function QualificationModal({
        openQualification,
        setOpenQualification,
        qualificationData,
        setQualificationData,
        courseLevels,
        qualificationList,
        streams,
        countriesList,
        qualificationStates,
        qualificationCities,
        affiliations,
        selectedQualification,
        enquiryId,
        setQualificationList,
        handleQualificationSave,
        handleQualificationCountryChange,
        handleQualificationStateChange,
    }) {

      const availableCourseLevels = courseLevels;

      return (
      <>
      <Dialog
                open={openQualification}
                onClose={() => setOpenQualification(false)}
                fullWidth
                maxWidth="xl"
              >
                <DialogTitle>Qualification Detail</DialogTitle>

                <DialogContent>
                  <Grid container spacing={2} mt={1}>

                    {/* Highest Qualification */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        required
                        fullWidth
                        label="Highest Qualification"
                        value={qualificationData.highestQualification}
                        onChange={(e) =>
                          setQualificationData({
                            ...qualificationData,
                            highestQualification: e.target.value,
                          })
                        }
                      >
                        {availableCourseLevels.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                  {item.course_level}
                              </MenuItem>
                          ))}
                      </TextField>
                    </Grid>

                    {/* Qualification Name */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="Qualification Name"
                        value={qualificationData.qualificationName}
                        onChange={(e) =>
                          setQualificationData({
                            ...qualificationData,
                            qualificationName: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    {/* Stream */}
                    <Grid item xs={12} md={3}>
                      <TextField
                          select
                          required
                          fullWidth
                          label="Stream"
                          value={qualificationData.stream}
                          onChange={(e) =>
                            setQualificationData({
                              ...qualificationData,
                              stream: e.target.value,
                            })
                          }
                        >
                          {streams.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.stream_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>

                    {/* Duration */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        label="Duration"
                        value={qualificationData.duration}
                        onChange={(e) =>
                          setQualificationData({
                            ...qualificationData,
                            duration: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="1 Year">1 Year</MenuItem>
                        <MenuItem value="2 Years">2 Years</MenuItem>
                        <MenuItem value="3 Years">3 Years</MenuItem>
                        <MenuItem value="4 Years">4 Years</MenuItem>
                        <MenuItem value="5 Years">5 Years</MenuItem>
                        <MenuItem value="6 Years">6 Years</MenuItem>
                        <MenuItem value="7 Years">7 Years</MenuItem>
                        <MenuItem value="8 Years">8 Years</MenuItem>
                        <MenuItem value="9 Years">9 Years</MenuItem>
                      </TextField>
                    </Grid>

                    {/* Country */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        required
                        size="small"
                        label="Country"
                        value={qualificationData.country}
                        onChange={handleQualificationCountryChange}
                        >
                        {countriesList.map((country) => (
                            <MenuItem
                                key={country.id}
                                value={country.id}
                            >
                                {country.country_name}
                            </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* State */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="State"
                        value={qualificationData.state}
                        onChange={handleQualificationStateChange}
                        >
                        {qualificationStates.map((state) => (
                              <MenuItem
                                  key={state.id}
                                  value={state.id}
                              >
                                  {state.state_name}
                              </MenuItem>
                          ))}
                        </TextField>
                    </Grid>

                    {/* City */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="City"
                        value={qualificationData.city}
                        onChange={(e) =>
                          setQualificationData((prev) => ({
                            ...prev,
                            city: e.target.value,
                          }))
                        }
                        >
                        {qualificationCities.map((city) => (
                            <MenuItem
                                key={city.id}
                                value={city.id}
                            >
                                {city.city_name}
                            </MenuItem>
                        ))}
                        </TextField>
                    </Grid>

                    {/* Affiliation */}
                    <Grid item xs={12} md={3}>
                      <TextField
                          select
                          fullWidth
                          size="small"
                          label="Affiliation"
                          value={qualificationData.affiliation}
                          onChange={(e) =>
                            setQualificationData((prev) => ({
                              ...prev,
                              affiliation: e.target.value,
                            }))
                          }
                          >
                          {(Array.isArray(affiliations) ? affiliations : []).map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.affiliation_name}
                            </MenuItem>
                          ))}
                          </TextField>
                    </Grid>

                    {/* Institution */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        required
                        label="Name of Institution"
                        value={qualificationData.institution}
                        onChange={(e) =>
                          setQualificationData({
                            ...qualificationData,
                            institution: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    {/* Education Status */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        required
                        fullWidth
                        label="Education Status"
                        value={qualificationData.educationStatus}
                        onChange={(e) =>
                          setQualificationData({
                            ...qualificationData,
                            educationStatus: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="Complete">Complete</MenuItem>
                        <MenuItem value="Incomplete">Incomplete</MenuItem>
                        <MenuItem value="Pursuing">Pursuing</MenuItem>
                      </TextField>
                    </Grid>

                    {/* Year */}
                    {qualificationData.educationStatus === "Complete" && (
                      <Grid item xs={12} md={3}>
                          <TextField
                              select
                              required
                              fullWidth
                              label="Year of Passing"
                              value={qualificationData.year}
                              onChange={(e) =>
                                  setQualificationData({
                                      ...qualificationData,
                                      year: e.target.value,
                                  })
                              }
                          >
                              {Array.from({ length: 40 }, (_, i) => {
                                  const year = new Date().getFullYear() - i;
                                  return (
                                      <MenuItem key={year} value={year}>
                                          {year}
                                      </MenuItem>
                                  );
                              })}
                          </TextField>
                      </Grid>
                  )}
              
              <Grid item xs={12} md={3}>
                  <TextField
                      fullWidth
                      label="Grade Point (CGPA)"
                      value={qualificationData.cgpa}
                      onChange={(e) => {
                          const value = e.target.value;

                          // Allow empty value
                          if (value === "") {
                              setQualificationData({
                                  ...qualificationData,
                                  cgpa: "",
                              });
                              return;
                          }

                          // Allow numbers with up to 2 decimal places
                          const regex = /^(10(\.0{1,2})?|[0-9](\.\d{0,2})?)$/;

                          if (regex.test(value)) {
                              setQualificationData({
                                  ...qualificationData,
                                  cgpa: value,
                              });
                          }
                      }}
                      inputProps={{
                          inputMode: "decimal",
                      }}
                  />
              </Grid>
               

                    {/* Percentage */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="Percentage"
                        type="number"
                        inputProps={{
                          min: 0,
                          max: 100,
                          step: 0.01,
                        }}
                        value={qualificationData.percentage}
                        onChange={(e) => {
                          let value = e.target.value;

                          if (value === "") {
                            setQualificationData({
                              ...qualificationData,
                              percentage: "",
                            });
                            return;
                          }

                          value = Number(value);

                          if (value >= 0 && value <= 100) {
                            setQualificationData({
                              ...qualificationData,
                              percentage: value,
                            });
                          }
                        }}
                       />
                    </Grid>

                    {/* Credits */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="Credits"
                        value={qualificationData.credits}
                        onChange={(e) =>
                          setQualificationData({
                            ...qualificationData,
                            credits: e.target.value,
                          })
                        }
                      />
                    </Grid>

                    {/* Backlogs */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        fullWidth
                        label="Re-appears/Backlogs"
                        type="number"
                        inputProps={{
                            min: 0,
                            step: 1,
                        }}
                        value={qualificationData.backlogs}
                        onChange={(e) => {
                            const value = e.target.value;

                            // Allow empty value
                            if (value === "") {
                                setQualificationData({
                                    ...qualificationData,
                                    backlogs: "",
                                });
                                return;
                            }

                            // Allow only whole numbers >= 0
                            if (/^\d+$/.test(value)) {
                                setQualificationData({
                                    ...qualificationData,
                                    backlogs: Number(value),
                                });
                            }
                        }}
                    />
                    </Grid>

                    {/* ECA */}
                    <Grid item xs={12} md={3}>
                      <TextField
                        select
                        fullWidth
                        label="ECA"
                        value={qualificationData.eca}
                        onChange={(e) =>
                          setQualificationData({
                            ...qualificationData,
                            eca: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </TextField>
                    </Grid>

                  </Grid>
                </DialogContent>

                <DialogActions>
                  <Button color="error" onClick={() => setOpenQualification(false)}>
                    Close
                  </Button>

                  <Button variant="contained" onClick={handleQualificationSave}>
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              </>
      )

  }
  export default QualificationModal;